module.exports = __webpack_public_path__ + "media/images/top/qa/ranking_banner-76b6d9660436e6af750fb909132f0418.png";